<template>
  <v-card>
    <v-container class="cyan" fluid>
      <v-progress-linear
        :active="downloading"
        :indeterminate="downloading"
        color="red"
      />

      <filter-header
        v-model="filters"
        @validated="filtersValidated"
        timeStepRequired
      />
      <v-btn
        @click="downloadSessionData"
        :loading="loading"
        :disabled="!valid"
        color="cyan lighten-1"
        elevation="6"
        large
      >
        ダウンロード
        <v-icon right color="white">mdi-cloud-download</v-icon>
      </v-btn>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col>
          <!-- <detection-chart :loading="loading" :filters="filters" /> -->
          <detection-chart :loading="loading" :filters="updatedFilters" />
        </v-col>
      </v-row>
      <v-divider />
      <v-row>
        <v-col>
          <!-- <gender-chart :loading="loading" :filters="filters" /> -->
          <gender-chart :loading="loading" :filters="updatedFilters" />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import { functions } from '@/config/firebase'
import FilterHeader from '@/components/report/FilterHeader'
import DetectionChart from '@/components/report/DetectionChart'
import GenderChart from '@/components/report/GenderChart'
import { reportFunctionsMixin, downloadFunctionsMixin } from '@/plugins/mixins'
import { fmt } from '@/plugins/datefns'
import { addDays, differenceInDays, endOfDay } from 'date-fns/esm'

export default {
  name: 'TimelineDashboard',
  components: {
    GenderChart,
    FilterHeader,
    DetectionChart
  },
  mixins: [reportFunctionsMixin, downloadFunctionsMixin],
  data: () => ({
    loading: false,
    valid: false,
    isAutoRefresh: false,
    filters: {},
    updatedFilters: {},
    downloading: false
  }),
  computed: {},
  methods: {
    ...mapActions({
      showSnack: 'snackbar/showSnack'
    }),
    showError(message) {
      this.showSnack({ message: `失敗しました: ${message}`, color: 'error' })
    },
    filtersValidated(valid) {
      this.valid = valid
    },
    updateData() {
      const startDate = new Date(this.filters.date.start)
      const endDate = new Date(this.filters.date.end)

      this.updatedFilters = this.filters
      this.updatedFilters.date.start = startDate
      this.updatedFilters.date.end = endDate
    },
    async downloadSessionData() {
      this.downloading = true

      const startDate = this.filters.date.start
      const endDate = this.filters.date.end
      const diffDays = differenceInDays(endDate, startDate) + 1

      let timeline = []
      // Populate start and end date by day.
      for (let i = 0; i < diffDays; i++) {
        const start = addDays(startDate, i)
        const time = {
          start: start.toString(),
          end: endOfDay(start).toString()
        }
        timeline.push(time)
      }

      const files = []
      for (const deviceId of this.filters.devices) {
        for (const time of timeline) {
          const filename = `S_${deviceId}_${fmt(
            new Date(time.start),
            'yyyy-MM-dd'
          )}.json`

          try {
            const task = functions.httpsCallable('report-DownloadSessionReport')
            // Create report file and get download url
            const result = await task({
              deviceId: deviceId,
              startDate: time.start,
              endDate: time.end
            })

            if (result.data.success) {
              files.push({ name: filename, url: result.data.url })
            }
          } catch (error) {
            this.showSnack({
              message: `${filename}のダウンロードに失敗しました`,
              color: 'error'
            })
            console.log(error)
          }
        }
      }

      if (files.length > 0) {
        const folderName = `ユーザーデータ_${new Date()}`
        const zipBlob = await this.zipDownloadedFiles(
          folderName,
          files.map(f => f.url),
          10
        )

        if (zipBlob !== undefined && zipBlob !== null) {
          const urlObj = URL.createObjectURL(zipBlob)
          const anchor = this.downloadFile(folderName, urlObj)
          const message = `データをダウンロードしました`
          this.showSnack({ message })

          // Tidy up URL object to release memory.
          URL.revokeObjectURL(urlObj)
          // Tidy up anchor tags. sometime fail to download
          // if removing anchor tag immediately, so delete them here
          anchor.remove()
        }
      }

      this.downloading = false
    }
  },
  watch: {
    filters() {
      if (this.filters.date.start && this.filters.date.end) {
        this.updateData()
      }
    }
  }
}
</script>
<style scoped>
.report-score h1,
h3,
h4 {
  text-align: center;
  font-weight: 200;
}
.report-title-mdi {
  font-size: 3.2rem !important;
}
.report-text-caption {
  color: grey;
  font-weight: 200;
  font-size: 1.2rem;
  letter-spacing: 0.2rem;
}
.report-text-main {
  font-size: 3rem;
  letter-spacing: 0.2rem;
}
.v-text-field__slot {
  background-color: white !important;
}
.v-input__slot {
  background-color: white !important;
}
</style>
